import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

type LoaderProps = {
  loading?: boolean;
  children?: React.ReactNode;
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100vh',
  },
}));

export const Loader: React.FC<LoaderProps> = ({ loading = true, children }: LoaderProps) => {
  const classes = useStyles();
  if (loading) {
    return (
      <div className={classes.root}>
        <CircularProgress />
      </div>
    );
  }

  return <div>{children}</div>;
};
export default Loader;
